import React from 'react'
import {graphql} from 'gatsby'
import {Section} from "../components/content";
import {Typography} from "../styles/typography";
import {Spacing} from "../styles/spacing";
import {css} from "@emotion/react";
import {eerieBlack} from "../styles/colors";
import {Body} from "../components/Body";
import Seo from "../components/Seo";
import {ResponsiveTypography} from "../styles/typography.responsive";

const templateCss = css`
  h1 {
    ${ResponsiveTypography.heading.h3_700}
    ${Spacing.Margin.top_40}
    ${Spacing.Margin.bottom_20}
  }

  h2 {
    ${ResponsiveTypography.heading.h4_700}
    ${Spacing.Margin.top_40}
    ${Spacing.Margin.bottom_20}
  }

  h3 {
    ${ResponsiveTypography.heading.h5_700}
    ${Spacing.Margin.top_40}
    ${Spacing.Margin.bottom_16}
  }

  h4 {
    ${ResponsiveTypography.heading.h5_500}
    ${Spacing.Margin.top_24}
    ${Spacing.Margin.bottom_16}
  }

  h5 {
    ${ResponsiveTypography.heading.h6_400}
    ${Spacing.Margin.top_16}
    ${Spacing.Margin.bottom_8}
  }

  h6 {
    ${ResponsiveTypography.heading.h6_400}
    ${Spacing.Margin.top_16}
    ${Spacing.Margin.bottom_8}
  }

  p {
    max-width: 100%;
    ${Typography.paragraph.p1_400}
    ${Spacing.Margin.bottom_16}
  }

  p, a, span {
    word-break: break-word;
  }

  hr {
    height: 1px;
    background-color: ${eerieBlack['200']};
    border: none;
    margin: 24px 0
  }

  pre{
    background: #272727;
    color: lime;
    padding: 20px;
    border-radius: 5px;
  }

  blockquote{
    background: #F5F5F5;
    border-left: 4px solid #ADADAD;
    padding: 17px 16px 1px;
    margin: 16px 8px;
    border-top-right-radius: 8px;
    border-top-left-radius: 2px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 2px;
    font-style: italic;
  }
`

// this prop will be injected by the GraphQL query below.
export default function MarkdownTemplate({data}) {
  const {markdownRemark} = data // data.markdownRemark holds your post data
  const {frontmatter, html} = markdownRemark

  const extraCss = frontmatter.css ? css`${frontmatter.css.replace('\n', '; ')}` : css`
  `
  return (
    <Body css={[Typography.fonts.inter]} safe={false}>
      <Seo title={frontmatter.title}/>

      <Section css={[templateCss, extraCss]}>
        <h1 css={[Typography.heading.h1_500, Spacing.Margin.bottom_24]}>
          {frontmatter.title}
        </h1>

        <div
          className="tate-markdown-content"
          dangerouslySetInnerHTML={{__html: html}}
        />
      </Section>
    </Body>
  )
}

export const query = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        css
      }
    }
  }
`
